import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { GroveLeaf } from './GroveLeaf';

interface AppShellProps {
  /** Narrow article list panel (left of reader) */
  list: React.ReactNode;
  /** Main reader/content panel */
  panel?: React.ReactNode;
  /** If true, panel takes up right side; otherwise list takes full width */
  showPanel?: boolean;
}

/** 3-column desktop layout: sidebar | article list | reader */
export function AppShell({ list, panel, showPanel }: AppShellProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-surface-bg">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />

      {/* Article list panel */}
      <div
        className="flex flex-col border-r border-border-subtle flex-shrink-0 overflow-hidden"
        style={{
          width: showPanel ? 340 : '100%',
          transition: 'width 0.15s ease',
        }}
      >
        {list}
      </div>

      {/* Reader panel */}
      {showPanel && panel && (
        <div className="flex-1 overflow-hidden">
          {panel}
        </div>
      )}

      {/* Empty state when no article selected */}
      {showPanel && !panel && (
        <div className="flex-1 flex items-center justify-center text-text-muted">
          <div className="text-center">
            <GroveLeaf size={40} style={{ opacity: 0.4, margin: '0 auto 12px' }} />
            <p className="text-sm">Select an article to read</p>
          </div>
        </div>
      )}
    </div>
  );
}
